  
import { useEffect, useState, useContext } from "react";

// Generate username from email
const generateUsernameFromEmail = (email) => {
  if (!email) return "";
  const prefix = email.split("@")[0].toLowerCase();
  const random = Math.floor(100 + Math.random() * 900);
  return `${prefix}${random}`;
};

// Generate employee ID
const generateEmployeeId = () => {
  const unique = Date.now().toString().slice(-6);
  return `EMP${unique}`;
};
// Validation helper
const validateEmail = (email) => {
  // Simple email regex
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const validateMobile = (mobile) => {
  // Indian mobile: 10 digits, starts with 6-9
  return /^[6-9][0-9]{9}$/.test(mobile);
};

const validatePincode = (pincode) => {
  // Indian pincode: 6 digits, starts with 1-9
  return /^[1-9][0-9]{5}$/.test(pincode);
};
import {
  Box,
  Grid,
  FormControl,
  FormLabel,
  Input,
  Button,
  Heading,
  useToast,
  Spinner,
  Select,
} from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchUserDetailsById,
  updateUserDetailsById,
} from "../../actions/users.action";
import { fetchRoles } from "../../actions/role.actions";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { AuthContext } from "../../providers/AuthValidationLayer";
import { Unauthorized } from "../../components/Unauthorized";
import { Select as ChakraSelect } from "chakra-react-select";

export default function EditAdmin() {
    const [errors, setErrors] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [roles, setRoles] = useState([]);
  const [admin, setAdmin] = useState(null);
  const { hasPermission } = useContext(AuthContext);
  const [addressProofFile, setAddressProofFile] = useState(null);
  const [idProofFile, setIdProofFile] = useState(null);
  const [addressProofPreview, setAddressProofPreview] = useState(null);
  const [idProofPreview, setIdProofPreview] = useState(null);

const [existingAddressProof, setExistingAddressProof] = useState([]);
const [existingIdProof, setExistingIdProof] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    roleId: "",
    mobileNumber: "",
    dateOfBirth: "",
    dateOfJoining: "",
    gender: "",
    languageKnown: [], // Now an array
    state: "",
    city: "",
    pincode: "",
    address: "",
    employeeId: "",
    department: "",
    team: "",
    designation: "",
    branch: "",
    shiftTimings: "",
    emergencyContactName: "",
    emergencyContactRelation: "",
    emergencyContactNumber: "",
  });


  // -------- handlers ----------
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    // Only allow numbers for mobile, emergency contact, and pincode
    if (["mobileNumber", "emergencyContactNumber", "pincode"].includes(name)) {
      let newValue = value.replace(/[^0-9]/g, "");
      if (name === "mobileNumber" || name === "emergencyContactNumber") {
        newValue = newValue.slice(0, 10);
      } else if (name === "pincode") {
        newValue = newValue.slice(0, 6);
      }
      setFormData((prev) => ({ ...prev, [name]: newValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: type === 'date' ? value : value }));
    }
  };

  // Handler for ChakraSelect multi-select for languageKnown
  const handleLanguageChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      languageKnown: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
    }));
  };
  // File change handler for address/id proof
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const setPreview = (setter, file) => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => setter(reader.result);
        reader.readAsDataURL(file);
      } else if (file.type === 'application/pdf') {
        const url = URL.createObjectURL(file);
        setter(url);
      } else {
        setter(null);
      }
    };

    if (type === "address") {
      setAddressProofFile(file);
      setPreview(setAddressProofPreview, file);
    } else {
      setIdProofFile(file);
      setPreview(setIdProofPreview, file);
    }
  };

  const loadData = async () => {
    try {
      setLoading(true);

      const adminData = await fetchUserDetailsById(id);
      const rolesData = await fetchRoles();

      setAdmin(adminData);
      setRoles(rolesData || []);
      setExistingAddressProof(adminData.addressProofFiles || []);
setExistingIdProof(adminData.idProofFiles || []);

      // If employeeId or username is missing, generate from email
      let employeeId = adminData.employeeId;
      let username = adminData.username;
      if (!employeeId) {
        employeeId = generateEmployeeId();
      }
      if (!username) {
        username = generateUsernameFromEmail(adminData.email);
      }

      setFormData({
        name: adminData.name || "",
        email: adminData.email || "",
        roleId: adminData.roleId?._id || "",
        mobileNumber: adminData.mobileNumber || "",
        // Fix: ensure dateOfBirth is always yyyy-mm-dd or empty
        dateOfBirth: adminData.dateOfBirth
          ? (adminData.dateOfBirth.length > 10
              ? adminData.dateOfBirth.slice(0, 10)
              : adminData.dateOfBirth)
          : "",
        dateOfJoining: adminData.dateOfJoining
          ? (adminData.dateOfJoining.length > 10
              ? adminData.dateOfJoining.slice(0, 10)
              : adminData.dateOfJoining)
          : "",
        gender: adminData.gender || "",
        // Fix: handle string, array, or array of comma-separated strings for languageKnown
        languageKnown: Array.isArray(adminData.languageKnown)
          ? adminData.languageKnown.flatMap((item) =>
              typeof item === 'string' && item.includes(',')
                ? item.split(',').map((s) => s.trim()).filter(Boolean)
                : (typeof item === 'string' && item.trim() !== '' ? [item.trim()] : [])
            )
          : (typeof adminData.languageKnown === "string")
            ? adminData.languageKnown.split(",").map((s) => s.trim()).filter(Boolean)
            : [],
        state: adminData.state || "",
        city: adminData.city || "",
        pincode: adminData.pincode || "",
        address: adminData.address || "",
        employeeId,
        username,
        department: adminData.department || "",
        team: adminData.team || "",
        designation: adminData.designation || "",
        branch: adminData.branch || "",
        shiftTimings: adminData.shiftTimings || "",
        emergencyContactName: adminData.emergencyContactName || "",
        emergencyContactRelation: adminData.emergencyContactRelation || "",
        emergencyContactNumber: adminData.emergencyContactNumber || "",
      });
    } catch (err) {
      toast({
        title: "Error",
        description: err.message || "Failed to load admin",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!validateEmail(formData.email.trim())) newErrors.email = "Invalid email format.";
    if (!formData.roleId) newErrors.roleId = "Role is required.";
    if (!formData.mobileNumber.trim()) newErrors.mobileNumber = "Mobile number is required.";
    else if (!validateMobile(formData.mobileNumber.trim())) newErrors.mobileNumber = "Invalid mobile number.";
    if (!formData.gender) newErrors.gender = "Gender is required.";
    if (!formData.languageKnown || formData.languageKnown.length === 0) newErrors.languageKnown = "Language is required.";
    if (!formData.state.trim()) newErrors.state = "State is required.";
    if (!formData.city.trim()) newErrors.city = "City is required.";
    if (!formData.pincode.trim()) newErrors.pincode = "Pincode is required.";
    else if (!validatePincode(formData.pincode.trim())) newErrors.pincode = "Invalid pincode.";
    if (!formData.address.trim()) newErrors.address = "Address is required.";
    if (!formData.department) newErrors.department = "Department is required.";
    // Emergency contact validations (optional, but if filled, must be valid)
    if (formData.emergencyContactNumber && !validateMobile(formData.emergencyContactNumber.trim())) {
      newErrors.emergencyContactNumber = "Invalid emergency contact number.";
    }
    // File validations (if selected)
    if (addressProofFile && !(addressProofFile.type.startsWith('image/') || addressProofFile.type === 'application/pdf')) {
      newErrors.addressProofFile = "Address proof must be an image or PDF.";
    }
    if (idProofFile && !(idProofFile.type.startsWith('image/') || idProofFile.type === 'application/pdf')) {
      newErrors.idProofFile = "ID proof must be an image or PDF.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast({
        title: "Validation Error",
        description: "Please fix the errors before submitting.",
        status: "error",
      });
      return;
    }

    const trimmedName = formData.name.trim();
    const trimmedEmail = formData.email.trim();

    try {
      setSaving(true);

      const formPayload = new FormData();

      // Append normal fields

      Object.keys(formData).forEach((key) => {
        if (key === "languageKnown") {
          // Send as comma-separated string for backend compatibility
          formPayload.append("languageKnown", formData.languageKnown.join(","));
        } else {
          formPayload.append(key, formData[key]);
        }
      });

      formPayload.set("name", trimmedName);
      formPayload.set("email", trimmedEmail);

      // Append files if re-uploaded
      if (addressProofFile) {
        formPayload.append("addressProofFiles", addressProofFile);
      }

      if (idProofFile) {
        formPayload.append("idProofFiles", idProofFile);
      }

      await updateUserDetailsById(id, formPayload);

      toast({
        title: "Success",
        description: "Admin updated successfully",
        status: "success",
      });

      navigate(`/settings/admin/${id}`);
    } catch (err) {
      toast({
        title: "Error",
        description: err.message || "Failed to update admin",
        status: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [id]);

  if (!hasPermission("Access Control", "Employees", "GET")) {
    return <Unauthorized />;
  }

  if (loading) {
    return (
      <Box p={6} display="flex" justifyContent="center">
        <Spinner size="lg" />
      </Box>
    );
  }

  if (!admin) return null;

  return (
    <Box p={6}>
      <BreadCrumbMaker
        items={[
          { link: "/settings", title: "Access Control" },
          { link: "/settings/admin/manage", title: "Admins" },
          { link: "#", title: "Edit Admin", on: true },
        ]}
      />

      <Box bg="white" p={6} borderRadius="2xl" mt={4}>
        <Heading size="md" mb={6}>
          Edit Admin
        </Heading>



        <form onSubmit={handleSubmit}>
          {/* Personal Details Section */}
          <Box bg="#F5F7FA" p={5} borderRadius="lg" mb={6} boxShadow="sm">
            <Heading size="sm" color="gray.600" mb={4} fontWeight="bold">Personal Details</Heading>
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
              <FormControl isRequired isInvalid={!!errors.name}>
                <FormLabel>Name</FormLabel>
                <Input name="name" value={formData.name} onChange={handleChange} />
                {errors.name && <Box color="red.500" fontSize="sm">{errors.name}</Box>}
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.email}>
                <FormLabel>Email</FormLabel>
                <Input type="email" name="email" value={formData.email} onChange={handleChange} />
                {errors.email && <Box color="red.500" fontSize="sm">{errors.email}</Box>}
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.mobileNumber}>
                <FormLabel>Mobile Number</FormLabel>
                <Input
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  type="tel"
                  pattern="[6-9]{1}[0-9]{9}"
                  maxLength={10}
                  inputMode="numeric"
                  autoComplete="off"
                />
                {errors.mobileNumber && <Box color="red.500" fontSize="sm">{errors.mobileNumber}</Box>}
              </FormControl>
              <FormControl>
                <FormLabel>Date of Birth</FormLabel>
                <Input name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} type="date" />
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.gender}>
                <FormLabel>Gender</FormLabel>
                <Select name="gender" value={formData.gender} onChange={handleChange} placeholder="Select Gender">
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </Select>
                {errors.gender && <Box color="red.500" fontSize="sm">{errors.gender}</Box>}
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.languageKnown}>
                <FormLabel>Language Known</FormLabel>
                <ChakraSelect
                  isMulti
                  name="languageKnown"
                  options={[
                    { value: "English", label: "English" },
                    { value: "Hindi", label: "Hindi" },
                    { value: "Marathi", label: "Marathi" },
                    { value: "Gujarati", label: "Gujarati" },
                    { value: "Tamil", label: "Tamil" },
                    { value: "Telugu", label: "Telugu" },
                    { value: "Kannada", label: "Kannada" },
                    { value: "Bengali", label: "Bengali" },
                    { value: "Punjabi", label: "Punjabi" },
                    { value: "Other", label: "Other" },
                  ]}
                  value={formData.languageKnown.map((lang) => ({ value: lang, label: lang }))}
                  onChange={handleLanguageChange}
                  placeholder="Select Language(s)"
                  closeMenuOnSelect={false}
                  chakraStyles={{
                    control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#CBD5E0", _hover: { borderColor: "#3182CE" } }),
                    menu: (base) => ({ ...base, zIndex: 10 }),
                  }}
                />
                {errors.languageKnown && <Box color="red.500" fontSize="sm">{errors.languageKnown}</Box>}
              </FormControl>
            </Grid>
          </Box>

          {/* Address Section */}
          <Box bg="#F5F7FA" p={5} borderRadius="lg" mb={6} boxShadow="sm">
            <Heading size="sm" color="gray.600" mb={4} fontWeight="bold">Address Details</Heading>
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
              <FormControl isRequired isInvalid={!!errors.state}>
                <FormLabel>State</FormLabel>
                <Input name="state" value={formData.state} onChange={handleChange} />
                {errors.state && <Box color="red.500" fontSize="sm">{errors.state}</Box>}
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.city}>
                <FormLabel>City</FormLabel>
                <Input name="city" value={formData.city} onChange={handleChange} />
                {errors.city && <Box color="red.500" fontSize="sm">{errors.city}</Box>}
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.pincode}>
                <FormLabel>Pincode</FormLabel>
                <Input
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  type="tel"
                  pattern="[1-9]{1}[0-9]{5}"
                  maxLength={6}
                  inputMode="numeric"
                  autoComplete="off"
                />
                {errors.pincode && <Box color="red.500" fontSize="sm">{errors.pincode}</Box>}
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.address}>
                <FormLabel>Address</FormLabel>
                <Input name="address" value={formData.address} onChange={handleChange} />
                {errors.address && <Box color="red.500" fontSize="sm">{errors.address}</Box>}
              </FormControl>
            </Grid>
          </Box>

          {/* Employment Section */}
          <Box bg="#F5F7FA" p={5} borderRadius="lg" mb={6} boxShadow="sm">
            <Heading size="sm" color="gray.600" mb={4} fontWeight="bold">Employment Details</Heading>
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
              <FormControl>
                <FormLabel>Employee ID</FormLabel>
                <Input name="employeeId" value={formData.employeeId} isReadOnly />
              </FormControl>
              <FormControl>
                <FormLabel>Username</FormLabel>
                <Input name="username" value={formData.username} isReadOnly />
              </FormControl>
              <FormControl isRequired isInvalid={!!errors.department}>
                <FormLabel>Department</FormLabel>
                <Select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  placeholder="Select Department"
                >
                  <option value="IT">IT</option>
                  <option value="HR">HR</option>
                  <option value="Sales">Sales</option>
                  <option value="Operations">Operations</option>
                  <option value="Finance">Finance</option>
                  <option value="Admin">Admin</option>
                  <option value="Support">Support</option>
                  <option value="Other">Other</option>
                </Select>
                {errors.department && <Box color="red.500" fontSize="sm">{errors.department}</Box>}
              </FormControl>
              <FormControl>
                <FormLabel>Team</FormLabel>
                <Input name="team" value={formData.team} onChange={handleChange} />
              </FormControl>
              <FormControl>
                <FormLabel>Designation</FormLabel>
                <Input name="designation" value={formData.designation} onChange={handleChange} />
              </FormControl>
              <FormControl>
                <FormLabel>Branch</FormLabel>
                <Input name="branch" value={formData.branch} onChange={handleChange} />
              </FormControl>
              <FormControl>
                <FormLabel>Shift Timings</FormLabel>
                <Input name="shiftTimings" value={formData.shiftTimings} onChange={handleChange} />
              </FormControl>
              <FormControl>
                <FormLabel>Date of Joining</FormLabel>
                <Input name="dateOfJoining" value={formData.dateOfJoining} onChange={handleChange} type="date" />
              </FormControl>
            </Grid>
          </Box>

          {/* Emergency Contact Section */}
          <Box bg="#F5F7FA" p={5} borderRadius="lg" mb={6} boxShadow="sm">
            <Heading size="sm" color="gray.600" mb={4} fontWeight="bold">Emergency Contact</Heading>
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
              <FormControl isInvalid={!!errors.emergencyContactName}>
                <FormLabel>Emergency Contact Name</FormLabel>
                <Input name="emergencyContactName" value={formData.emergencyContactName} onChange={handleChange} />
                {errors.emergencyContactName && <Box color="red.500" fontSize="sm">{errors.emergencyContactName}</Box>}
              </FormControl>
              <FormControl isInvalid={!!errors.emergencyContactRelation}>
                <FormLabel>Emergency Contact Relation</FormLabel>
                <Input name="emergencyContactRelation" value={formData.emergencyContactRelation} onChange={handleChange} />
                {errors.emergencyContactRelation && <Box color="red.500" fontSize="sm">{errors.emergencyContactRelation}</Box>}
              </FormControl>
              <FormControl isInvalid={!!errors.emergencyContactNumber}>
                <FormLabel>Emergency Contact Number</FormLabel>
                <Input
                  name="emergencyContactNumber"
                  value={formData.emergencyContactNumber}
                  onChange={handleChange}
                  type="tel"
                  pattern="[6-9]{1}[0-9]{9}"
                  maxLength={10}
                  inputMode="numeric"
                  autoComplete="off"
                />
                {errors.emergencyContactNumber && <Box color="red.500" fontSize="sm">{errors.emergencyContactNumber}</Box>}
              </FormControl>
            </Grid>
          </Box>

          {/* Role Section */}
          <Box bg="#F5F7FA" p={5} borderRadius="lg" mb={6} boxShadow="sm">
            <Heading size="sm" color="gray.600" mb={4} fontWeight="bold">Role & Access</Heading>
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
              <FormControl isRequired isInvalid={!!errors.roleId}>
                <FormLabel fontWeight="600" color="gray.700">Role</FormLabel>
                <ChakraSelect
                  placeholder="Select a role"
                  size="lg"
                  options={roles}
                  value={roles.find((r) => r._id === formData.roleId) || null}
                  getOptionLabel={(option) => option.roleName}
                  getOptionValue={(option) => option._id}
                  onChange={(selected) => setFormData((prev) => ({ ...prev, roleId: selected?._id || "" }))}
                  chakraStyles={{
                    control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#CBD5E0", _hover: { borderColor: "#3182CE" } }),
                    menu: (base) => ({ ...base, zIndex: 10 }),
                  }}
                />
                {errors.roleId && <Box color="red.500" fontSize="sm">{errors.roleId}</Box>}
              </FormControl>
            </Grid>
          </Box>
          
          {/* Documents Section */}
<Box bg="#F5F7FA" p={5} borderRadius="lg" mb={6} boxShadow="sm">
  <Heading size="sm" color="gray.600" mb={4} fontWeight="bold">
    Documents
  </Heading>

  {/* Address Proof */}


  <FormControl mb={5} isInvalid={!!errors.addressProofFile}>
    <FormLabel>Re-upload Address Proof</FormLabel>
    <Input
      type="file"
      accept="image/*,application/pdf"
      onChange={(e) => handleFileChange(e, "address")}
    />
    {errors.addressProofFile && <Box color="red.500" fontSize="sm">{errors.addressProofFile}</Box>}
    {addressProofPreview && (
      <Box mt={2}>
        {addressProofFile && addressProofFile.type.startsWith('image/') ? (
          <img src={addressProofPreview} alt="Address Proof Preview" style={{ maxWidth: 180, maxHeight: 180, borderRadius: 8 }} />
        ) : addressProofFile && addressProofFile.type === 'application/pdf' ? (
          <embed src={addressProofPreview} type="application/pdf" width="180" height="180" style={{ borderRadius: 8 }} />
        ) : (
          <Box color="gray.400">Preview not available</Box>
        )}
      </Box>
    )}
  </FormControl>

  {/* ID Proof */}

  <FormControl isInvalid={!!errors.idProofFile}>
    <FormLabel>Re-upload ID Proof</FormLabel>
    <Input
      type="file"
      accept="image/*,application/pdf"
      onChange={(e) => handleFileChange(e, "id")}
    />
    {errors.idProofFile && <Box color="red.500" fontSize="sm">{errors.idProofFile}</Box>}
    {idProofPreview && (
      <Box mt={2}>
        {idProofFile && idProofFile.type.startsWith('image/') ? (
          <img src={idProofPreview} alt="ID Proof Preview" style={{ maxWidth: 180, maxHeight: 180, borderRadius: 8 }} />
        ) : idProofFile && idProofFile.type === 'application/pdf' ? (
          <embed src={idProofPreview} type="application/pdf" width="180" height="180" style={{ borderRadius: 8 }} />
        ) : (
          <Box color="gray.400">Preview not available</Box>
        )}
      </Box>
    )}
  </FormControl>
</Box>
          <Button mt={6} colorScheme="blue" type="submit" isLoading={saving} loadingText="Saving...">
            Save Changes
          </Button>
          <Button mt={6} ml={3} variant="ghost" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </form>
      </Box>
    </Box>
  );
}
